 /**
 * Texts for Notifications page
 */
export const notificationsPageText = {
    title: 'Nedávná oznámení v aplikaci',
    titleMeta: 'Zobrazují se poslední oznámení v aplikaci CamAPS FX',
    descriptionMeta: 'Zde je text nedávných oznámení v aplikaci týkajících se aktualizací aplikací, bezpečnostních upozornění a aktualizací uživatelských příruček',
    keywords: 'oznámení' ,
    localeMeta: 'cs_cz',

    heading: 'Nedávná oznámení v aplikaci',
    subheading: '',

    header_133:'',
    body_133:'',

    header_132:'Aktualizace aplikace Android (YpsoPump only) 28/10/2026',
    body_132:'Vážený uživateli CamAPS FX, nová verze aplikace 1.4(195) bude k dispozici v následujících několika dnech. Prosím, zvolte si preferovaný čas aktualizace deaktivací automatické aktualizace pro CamAPS FX v Obchodu Google Play. Pokud máte jakékoli dotazy, kontaktujte prosím zákaznický servis mylife-Diabetescare.',

    header_131:'',
    body_131:'',

    header_130:'Je vyžadována aktualizace (pouze YpsoPump) 20/10/2026',
    body_130:'Je vyžadována aktualizace! Tato verze aplikace CamAPS FX může častěji padat a restartovat se. Aktualizujte prosím aplikaci na nejnovější verzi NYNÍ prostřednictvím Obchodu Google Play. Verze aplikace 1.4(190) bude dne 20/11/2026 ukončena. Po tomto datu nebude „Auto mode“ k dispozici, dokud aplikaci neaktualizujete. Podávání inzulinu prostřednictvím pumpy bude pokračovat.',

    header_129:'',
    body_129:'',

    header_128:'Aktualizace uživatelské příručky (pouze YpsoPump) 15/10/2026',
    body_128:'K dispozici je aktualizovaná verze uživatelské příručky. Najdete ji v hlavní nabídce CamAPS FX výběrem možnosti Nápověda po aktualizaci na nejnovější verzi aplikace.',

    header_127:'Aktualizace aplikace iOS (YpsoPump only) 08/10/2026',
    body_127:'Vážený uživateli CamAPS FX, NOVÁ VERZE aplikace 1.4(196) bude k dispozici v následujících dnech. DEAKTIVUJTE AUTOMATICKÉ AKTUALIZACE CamAPS FX v App Store, abyste si mohli vybrat preferovaný čas aktualizace. Pokud máte jakékoliv dotazy, obraťte se prosím na zákaznický servis mylife-Diabetescare.',

    header_126:'Aktualizace aplikace Android (YpsoPump only) 02/10/2026',
    body_126:'Vážený uživateli CamAPS FX, nová verze aplikace 1.4(194) bude k dispozici v následujících několika dnech. Prosím, zvolte si preferovaný čas aktualizace deaktivací automatické aktualizace pro CamAPS FX v Obchodu Google Play. Pokud máte jakékoli dotazy, kontaktujte prosím zákaznický servis mylife-Diabetescare.',

    header_125:'',
    body_125:'',

    header_124:'',
    body_124:'',

    header_123:'',
    body_123:'',

    header_122:'',
    body_122:'',

    header_121:'Apple iOS 27 vydání 11/09/2026',
    body_121:'Apple brzy uvolní iOS 27. Abyste zajistili nepřerušené používání aplikace CamAPS FX, PŘED aktualizací vašeho iPhonu na iOS 27 si ověřte kompatibilitu smartphonu a operačního systému na webových stránkách výrobce senzoru. Automatické aktualizace mohou být ve výchozím nastavení telefonu ZAPNUTÉ, proto prosím zvažte jejich VYPNUTÍ.',

    header_120:'',
    body_120:'',

    header_119:'Aktualizace uživatelské příručky (pouze YpsoPump) 10/09/2026',
    body_119:'K dispozici je aktualizovaná verze uživatelské příručky. Najdete ji v hlavní nabídce CamAPS FX výběrem možnosti Nápověda po aktualizaci na nejnovější verzi aplikace.',

    header_118:'Aktualizace aplikace Android (YpsoPump only) 07/09/2026',
    body_118:'Vážený uživateli CamAPS FX, nová verze aplikace 1.4(193) bude k dispozici v následujících několika dnech. Prosím, zvolte si preferovaný čas aktualizace deaktivací automatické aktualizace pro CamAPS FX v Obchodu Google Play. Pokud máte jakékoli dotazy, kontaktujte prosím zákaznický servis mylife-Diabetescare.',

    header_117:'',
    body_117:'',

    header_116:'',
    body_116:'',

    header_115:'',
    body_115:'',

    header_114:'',
    body_114:'',

    header_113:'',
    body_113:'',

    header_112:'',
    body_112:'',

    header_111:'Deaktivace verzí Android nižších než 1.4(192) (Ypsopump only) 03/08/2026',
    body_111:'Vážený uživateli CamAPS FX, z důvodů kybernetické bezpečnosti budou verze NIŽŠÍ NEŽ 1.4(192) UKONČENY dne 31/08/2026. Ujistěte se prosím, že je vaše aplikace AKTUALIZOVÁNA na verzi 1.4(192) před tímto datem. Pokud máte jakékoli dotazy, kontaktujte zákaznický servis mylife-Diabetescare.',

    header_110:'',
    body_110:'',
    body_110_link_text:'',
    body_110_end: '',
    body_110_link:'',

    header_109:'Vydání Android OS 17 24/06/2026',
    body_109:'Android brzy vydá OS 17. Abyste zajistili nepřerušené používání aplikace CamAPS FX, PŘED aktualizací systému Android na OS 17 si ověřte kompatibilitu smartphonu a operačního systému na webových stránkách výrobce senzoru. Automatické aktualizace mohou být ve výchozím nastavení telefonu ZAPNUTÉ, proto je prosím VYPNĚTE.',

    header_108:'Dexcom G7 je k dispozici (pouze Ypsopump) 23/06/2026',
    body_108:'Integrace CGM systému Dexcom G7 je nyní k dispozici! Uživatelé přecházející z Dexcom G6 naleznou na našich webových stránkách průvodce přechodem, pokyny pro řešení problémů a přehled kompatibilních CGM systémů: www.mylife-diabetescare.com.',

    header_107:'',
    body_107:'',

    header_106:'Aktualizace uživatelské příručky (pouze YpsoPump) 22/06/2026',
    body_106:'K dispozici je aktualizovaná verze uživatelské příručky. Najdete ji v hlavní nabídce CamAPS FX výběrem možnosti Nápověda.',

    header_105:'',
    body_105:'',

    header_104:'',
    body_104:'',

    header_103:'Aktualizace aplikace Android (YpsoPump only) 12/06/2026',
    body_103:'Vážený uživateli mylife CamAPS FX, nová verze aplikace 1.4(192) bude k dispozici v následujících několika dnech. Prosím, zvolte si preferovaný čas aktualizace deaktivací automatické aktualizace pro CamAPS FX v Obchodu Google Play. Pokud máte jakékoli dotazy, kontaktujte prosím zákaznický servis mylife-Diabetescare.',

    header_102:'',
    body_102:'',

    header_101:'',
    body_101:'',

    header_100:'',
    body_100:'',

    header_99:'',
    body_99:'',

    header_98:'Ukončení podpory starých operačních systémů 22/05/2026',
    body_98:'V souvislosti s přípravou další aktualizace aplikace CamAPS FX, vezměte prosím na vědomí, že příští verze aplikace bude PODPOROVÁNA POUZE na telefonech kompatibilních se senzorem, které používají OS 13 nebo novější, případně Apple iOS 18 nebo novější. Po vydání této verze uživatelé s telefony s verzí NIŽŠÍ než OS 13 nebo iOS 18 NEBUDOU moci CamAPS FX AKTUALIZOVAT ani ZNOVU NAINSTALOVAT.',

    header_97:'Aktualizace aplikace iOS 22/05/2026',
    body_97:'Vážený uživateli CamAPS FX, nová verze CamAPS FX, 1.4(195), bude k dispozici v následujících dnech. Chcete-li si zvolit, kdy aktualizaci provést, deaktivujte prosím AUTOMATICKÉ AKTUALIZACE v App Store. Uživatelé s verzí NIŽŠÍ než Apple iOS 18 NEBUDOU moci CamAPS FX na tuto verzi AKTUALIZOVAT. K dispozici je aktualizovaná verze uživatelské příručky. V případě dotazů kontaktujte zákaznický servis mylife-Diabetescare.',

    header_96:'',
    body_96:'',

    header_95:'',
    body_95:'',

    header_94:'',
    body_94:'',

    header_93:'Deaktivace verzí iOS nižších než 1.4(193) (pouze Ypsopump) 22/04/2026',
    body_93:'Vážený uživateli CamAPS FX, z důvodů kybernetické bezpečnosti budou VERZE NIŽŠÍ než 1.4(193) dne 30. dubna UKONČENY. Ujistěte se prosím, že je vaše aplikace před tímto datem AKTUALIZOVÁNA na verzi 1.4(193). V případě dotazů kontaktujte zákaznický servis mylife-Diabetescare.',

    header_92:'Ukončení podpory starších operačních systémů 21/04/2026',
    body_92:'Z důvodů kybernetické bezpečnosti bude mylife CamAPS FX od 30. června 2026 podporován POUZE na telefonech kompatibilních se senzorem, které používají následující operační systémy: Android OS 13 a vyšší a Apple iOS 18 a vyšší. Uživatelé operačních systémů NIŽŠÍCH než Android OS 13 nebo Apple iOS 18 NEBUDOU moci po tomto datu AKTUALIZOVAT ani ZNOVU NAINSTALOVAT mylife CamAPS FX.',

    header_91:'',
    body_91:'',
    body_91_link_text:'',
    body_91_end: '',
    body_91_link:'',

    header_90:'',
    body_90:'',

    header_89:'Aktualizace Dexcom G7 (pouze Ypsopump) 07/04/2026',
    body_89:'Blížíme se! Kompatibilita systému kontinuálního monitorování glukózy Dexcom G7 s aplikací mylife CamAPS FX bude dostupná v létě 2026. Budeme vás informovat, jakmile se uvedení na trh přiblíží.',

    header_88:'',
    body_88:'',

    header_87:'Deaktivace verzí iOS nižších než 1.4(193) (pouze Ypsopump) 16/03/2026',
    body_87:'Vážený uživateli CamAPS FX, z důvodů kybernetické bezpečnosti budou VERZE NIŽŠÍ než 1.4(193) dne 31. března UKONČENY. Ujistěte se prosím, že je vaše aplikace před tímto datem AKTUALIZOVÁNA na verzi 1.4(193). V případě dotazů kontaktujte zákaznický servis mylife-Diabetescare.',

    header_86:'',
    body_86:'',
    body_86_link_text:'',
    body_86_end: '',
    body_86_link:'',

    header_85:'',
    body_85:'',

    header_84:'',
    body_84:'',

    header_83:'',
    body_83:'',

    header_82:'Aktualizace aplikace pro Android (pouze Ypsopump) 02/02/2026',
    body_82:'Vážený uživateli CamAPS FX, v následujících dnech bude k dispozici NOVÁ VERZE aplikace – 1.4(190). DEAKTIVUJTE AUTOMATICKÉ AKTUALIZACE CamAPS FX v obchodě Google Play, abyste si mohli zvolit preferovaný čas aktualizace. Z důvodů kybernetické bezpečnosti budou VERZE NIŽŠÍ než 1.4(190) dne 31. března UKONČENY. V případě dotazů kontaktujte zákaznický servis mylife-Diabetescare.',

    header_81:'',
    body_81:'',

    header_80:'Pokyny k kompatibilitě (pouze YpsoPump) 19/01/2026',
    body_80:'Pokyny ke kompatibilitě: Pokud plánujete přejít na jiný typ senzoru, vždy si  předem ověřte  kompatibilitu svého mobilního telefonu a operačního systému.',

    header_79:'Senzor FreeStyle Libre 3 Plus v České republice (pouze pro YpsoPump) 05/01/2026',
    body_79:'Senzor FreeStyle Libre 3 Plus je nyní dostupný v ČR. Spárujte znovu svou pumpu mylife YpsoPump s aplikací mylife CamAPS FX, aby se tato možnost zobrazila v aplikaci. Navštivte stránku camdiab.com/cz/faq, kde si ověříte kompatibilitu smartphonu a operačního systému.',

    header_78:'',
    body_78:'',

    header_77:'',
    body_77:'',

    header_76:'',
    body_76:'',

    header_75:'',
    body_75:'',

    header_74:'Zpráva od mylife-Diabetescare (pouze YpsoPump) 09/12/2025',
    body_74:'Zásobník  mylife YpsoPump můžete ještě  jednou doplnit do 7 dnů od prvního naplnění. Další informace najdete na stránce Zásobník na webu mylife-diabetescare.',

    header_73:'',
    body_73:'',
    body_73_link_text:'',
    body_73_end: '',
    body_73_link:'',

    header_72:'',
    body_72:'',
    body_72_link_text:'',
    body_72_end: '',
    body_72_link:'',

    header_71:'',
    body_71:'',
    body_71_link_text:'',
    body_71_end: '',
    body_71_link:'',

    header_70:'Důležité bezpečnostní informace o senzoru systému FreeStyle Libre 3 25/11/2025',
    body_70:'Společnost Abbott zjistila, že některé senzory FreeStyle Libre 3 a FreeStyle Libre 3 Plus mohou potenciálně zobrazovat nesprávné hodnoty nízké hladiny glukózy. Pokud hodnoty senzoru neodpovídají vašim příznakům nebo očekáváním, vypněte automatický režim a pro rozhodnutí o léčbě použijte glukometr. V případě jakýchkoli dotazů, hlášení problémů nebo organizace výměny se obraťte na svůj výzkumný tým.',
    body_70_link_text:'',
    body_70_end: '',
    body_70_link:'',
	
    header_69:'Aktualizace aplikace iOS (pouze YpsoPump) 25/11/2025',
    body_69:'Vážený uživateli mylife CamAPS FX, NOVÁ VERZE aplikace bude k dispozici v příštích několika dnech. DEAKTIVUJTE AUTOMATICKÉ AKTUALIZACE CamAPS FX v App Store, abyste si vybrali preferovaný čas aktualizace. Vaše aktuální verze bude UKONČENA 9. prosince 2025. Pokud máte jakékoli dotazy, prosím, kontaktujte zákaznický servis Ypsomed.',
	
    header_68:'',
    body_68:'',

    header_67:'',
    body_67:'',
	
    header_66:'',
    body_66:'',
    body_66_link_text:'',
    body_66_end: '',
    body_66_link:'',

    header_65:'',
    body_65:'',
    body_65_link_text:'',
    body_65_end: '',
    body_65_link:'',

    header_64:'',
    body_64:'',
    body_64_link_text:'',
    body_64_end: '',
    body_64_link:'',

    header_63:'',
    body_63:'',
    body_63_link_text:'',
    body_63_end: '',
    body_63_link:'',

    header_62:'BEZPEČNOSTNÍ UPOZORNĚNÍ V TERÉNU 28/10/2025',
    body_62:'Přečtěte si a potvrďte čtení důležitého upozornění',
    body_62_link_text:'N-0125',
    body_62_end: '. Přejděte do Menu aplikace -> Bezpečnostní upozornění.',
    body_62_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET8374+Mylife+Users+CZ+final.pdf',

    header_61:'Aktualizace aplikace iOS (pouze YpsoPump) 02/10/2025',
    body_61:'Pro optimální výkon aplikace, prosím AKTUALIZUJTE svůj mylife CamAPS FX na NEJNOVĚJŠÍ VERZI (1.4(192)) přes Apple App Store.',

    header_60:'',
    body_60:'',

    header_59:'Aktualizace aplikace iOS (pouze YpsoPump) 22/09/2025',
    body_59:'Vážený uživateli mylife CamAPS FX, NOVÁ VERZE aplikace bude k dispozici v následujících dnech. DEAKTIVUJTE AUTOMATICKÉ AKTUALIZACE CamAPS FX v App Store, abyste si mohli vybrat preferovaný čas aktualizace. Nová verze uživatelské příručky bude k dispozici. Pokud máte jakékoliv dotazy, obraťte se prosím na zákaznický servis Ypsomed.',

    header_58:'Uvolnění iOS 26 (pouze pro YpsoPump) 13/09/2025',
    body_58:'Apple brzy uvolní iOS 26. Aby bylo zajištěno nepřetržité používání aplikace mylife CamAPS FX, prosím zkontrolujte webové stránky výrobce senzoru, abyste ověřili kompatibilitu vašeho smartphonu a operačního systému před aktualizací vašeho iPhonu na iOS 26. Poznámka: Automatické aktualizace mohou být ve výchozím nastavení zapnuty v nastavení vašeho telefonu, prosím vypněte je.',

    header_57:'Aktualizace aplikace Android (pouze YpsoPump) 26/08/2025',
    body_57:'Vážený uživateli mylife CamAPS FX, nová verze aplikace bude k dispozici za 2 až 3 dny. Prosím, zvolte si preferovaný čas aktualizace deaktivací automatické aktualizace pro CamAPS FX v Obchodu Google Play. Nová verze uživatelské příručky bude k dispozici. Pokud máte jakékoli dotazy, kontaktujte prosím zákaznický servis Ypsomed.',

    header_56:'',
    body_56:'',

    header_55:'',
    body_55:'',

    header_54:'',
    body_54:'',

    header_53:'',
    body_53:'',
	
    header_52:'',
    body_52:'',

    header_51:'',
    body_51:'',

    header_50:'',
    body_50:'',

    header_49:'Ukončení starších verzí aplikace 01/07/2025',
    body_49:'Prosím, aktualizujte svou aplikaci na nejnovější verzi dostupnou v Google Play. Stávající verze přestane fungovat 1. srpna 2025.',

    header_48:'OS 10 & 11 25/06/2025',
    body_48:'Z důvodů kybernetické bezpečnosti bude od 1.8.2025 aplikace mylife CamAPS FX u kompatibilních telefonů Android se senzory, dostupná pouze pro operační systém verze 12 a výše. Uživatelé operačních systémů nižších než OS 12 nebudou moci po tomto datu mylife CamAPS FX aktualizovat ani znovu instalovat. Pokud máte jakékoli dotazy, kontaktujte zákaznický servis Ypsomed.',

    header_47:'Vydání pro iOS (pouze YpsoPump) 09/06/2025',
    body_47:'Aplikace mylife CamAPS FX je nyní k dispozici také pro iPhony! Verze pro iOS a Android se v některých vlastnostech pro uživatele liší. ' +
   'Pokud uvažujete o přechodu na iOS, podrobné informace naleznete v sekci „Důležité informace pro uživatele iOS“ na stránkách www.mylife-diabetescare.com/cs-CZ/mylife-loop.html.',

    header_46:'',
    body_46:'',

    header_45:'Android OS 16 09/06/2025',
    body_45:'Aby bylo zajištěno nepřetržité používání aplikace mylife CamAPS FX, zkontrolujte, prosím, webové stránky výrobce senzoru, zda schválil kompatibilitu před aktualizací na Android OS 16. Upozorňujeme, že v nastavení telefonu mohou být zapnuté automatické aktualizace.',

    header_44:'Aktualizace uživatelské příručky 20/05/2025',
    body_44:'K dispozici je aktualizovaná verze uživatelské příručky.',

    header_43:'',
    body_43:'',

    header_42:'',
    body_42:'',

    header_41:'',
    body_41:'',

    header_40:'Nová aktualizace (18/03/2025)',
    body_40:'Vážení uživatelé mylife CamAPS FX, během následujících 48 hodin bude k dispozici nová verze aplikace. Chcete-li zvolit preferovaný čas aktualizace, vypněte prosím automatickou aktualizaci v obchodě Google Play. V případě jakýchkoli dotazů se obraťte na zákaznický servis společnosti Ypsomed.',

    header_39:'',
    body_39:'',

    header_38:'',
    body_38:'',

    header_37:'Zrušení staré verze aplikace (pouze Ypsopump)',
    body_37:'Prosím, aktualizujte svou aplikaci na nejnovější verzi dostupnou v Google Play. Stávající verze přestane fungovat 7. února 2025.',

    header_36:'Nová aktualizace 06/01/2025',
    body_36:'Vážený uživateli mylife CamAPS FX, Nová verze aplikace bude připravena během následujících 48 hodin. Abyste si mohli vybrat preferovaný čas aktualizace, vypněte automatickou aktualizaci pro CamAPS FX v Google Play Store. Pokud máte jakékoliv dotazy, kontaktujte zákaznickou podporu Ypsomed.',
	
	header_35:'OS 8 & 9 29/12/2024',
    body_35:'Z důvodů  kybernetické bezpečnosti bude od 1.1.2025 aplikace mylife CamAPS FX u kompatibilních telefonů Android se senzory, dostupná pouze pro operační systém verze 10 a výše. Uživatelé operačních systémů nižších než OS 10 nebudou moci po tomto datu mylife CamAPS FX aktualizovat ani znovu instalovat. Pokud máte jakékoli dotazy, kontaktujte zákaznický servis Ypsomed. Připomínka, systém ještě není kompatibilní s OS15.',
	
	header_34:'',
    body_34:'',
	
	header_33:'Oznámení o plánované údržbě 05/12/2024',
    body_33:'Vzhledem k naplánované údržbě cloudu služby CamAPS FX nebude funkce Companion dostupná 7. prosince od 10:00 GMT přibližně po dobu tří hodin. Omlouváme se za případné nepříjemnosti, které mohou nastat.',
	
	header_32:'Aktualizace uživatelské příručky 28/11/2024',
    body_32:'K dispozici je aktualizovaná verze uživatelské příručky.',
	
	header_31:'Nová aktualizace 17/11/2024',
    body_31:'Vážený uživateli mylife CamAPS FX, Nová verze aplikace bude připravena během následujících 48 hodin. Abyste si mohli vybrat preferovaný čas aktualizace, vypněte automatickou aktualizaci pro CamAPS FX v Google Play Store. Pokud máte jakékoliv dotazy, kontaktujte zákaznickou podporu Ypsomed.',
	
	header_30:'OS 8 & 9 11/10/2024',
    body_30:'Z divide kybernetické bezpečnosti bude od 1.1.2025 aplikace mylife CamAPS FX u kompatibilních telefonů Android se senzory, dostupná pouze pro operační systém verze 10 a výše. Uživatelé operačních systémů nižších než OS 10 nebudou moci po tomto datu mylife CamAPS FX aktualizovat ani znovu instalovat.“ Pokud máte jakékoli dotazy, kontaktujte zákaznický servis Ypsomed.',
	
	header_29:'Nová aktualizace 09/10/2024',
    body_29:'Vážený uživateli mylife CamAPS FX, Nová verze aplikace bude připravena během následujících 48 hodin. Abyste si mohli vybrat preferovaný čas aktualizace, vypněte automatickou aktualizaci pro CamAPS FX v Google Play Store. Pokud máte jakékoliv dotazy, kontaktujte zákaznickou podporu Ypsomed.',

	header_28:'OS 8 & 9 08/07/2024',
    body_28:'Z divide kybernetické bezpečnosti bude od 1.1.2025 aplikace mylife CamAPS FX u kompatibilních telefonů Android se senzory, dostupná pouze pro operační systém verze 10 a výše. Uživatelé operačních systémů nižších než OS 10 nebudou moci po tomto datu mylife CamAPS FX aktualizovat ani znovu instalovat.“ Pokud máte jakékoli dotazy, kontaktujte zákaznický servis Ypsomed.',

    header_27:'',
    body_27:'',
     
	header_26:'Aktualizace uživatelské příručky 11/05/2024',
    body_26:'K dispozici je aktualizovaná verze uživatelské příručky.',
	
	header_25:'',
    body_25:'',
	
	header_24:'',
    body_24:'',
	
	header_23:'Nová aktualizace 24/04/2024',
    body_23:'Vážený uživateli mylife CamAPS FX, děkujeme vám za vaši trpělivost. Nová verze aplikace 1.4(180) je dokončena a bude zpřístupněna během následujících 24 hodin. Chcete-li zvolit preferovaný čas aktualizace, vypněte automatickou aktualizaci v obchodě Google Play. V případě jakýchkoli dotazů se obraťte na zákaznický servis společnosti Ypsomed.  Omlouváme se za případné nepříjemnosti, které Vám mohly být tímto způsobeny. Váš tým CamDiab',
	
	header_22:'Aktualizace uživatelské příručky 13/04/2024',
    body_22:'K dispozici je aktualizovaná verze uživatelské příručky.',
	
	header_21:'',
    body_21:'',
	
	header_20:'Nová aktualizace 25/03/2024',
    body_20:'Vážený uživateli mylife CamAPS FX,  víme, že u některých z Vás nadále přetrvávají problémy s poslední aktualizací. V současné době rozšiřujeme testování opravy na širší skupinu uživatelů. Jakmile bude opravná verze k dispozici v obchodu Google Play, budeme Vás ihned informovat. Děkujeme vám za trpělivost, Váš tým CamDiab.',
	
	header_19:'Nová aktualizace 21/03/2024',
    body_19:'Někteří uživatelé se stále potýkají s problémy se současnou verzí mylife CamAPS FX, a proto finalizujeme vydání opravy chyb a testování ve verzi 1.4(180). O plánovaném vydání aktualizace budete brzy informováni. Omlouváme se za případné nepříjemnosti, které Vám mohli být tímto způsobeny.',
	
	header_18:'Nová aktualizace 17/03/2024',
    body_18:'Omlouváme se za trvající problémy, které někteří uživatelé mohou zažívat s nejnovější verzí. Nová aktualizace (verze 1.4(179)) bude k dispozici v pondělí. Pokud si přejete vybrat preferovaný čas pro aktualizaci, vypněte automatické aktualizace v Google Play. Pokud máte ztrátu dat v aplikaci Glooko, prosím znovu propojte svůj účet Glooko v nabídce ‘Sdílet’',
	
	header_17:'Nová aktualizace 11/03/2024',
    body_17:'Omlouváme se za pokračující problémy, které někteří uživatelé zažívají s nejnovější verzí aplikace. Nová aktualizace, která odstraňuje tyto problémy (verze 1.4(178)), bude k dispozici již zítra.Chcete-li si vybrat preferovaný čas aktualizace, zakažte automatické aktualizace v Obchodě Google Play.',
	
	header_16:'Aktualizace uživatelské příručky 04/03/2024',
    body_16:'K dispozici je aktualizovaná verze uživatelské příručky.',
	
	header_15:'Aktualizace uživatelské příručky 04/01/2024',
    body_15:'K dispozici je aktualizovaná verze uživatelské příručky.',
	
	header_14:'Android OS 14. 22/11/2023',
    body_14:'Připomínka: Aby bylo zajištěno nepřetržité používání aplikace mylife CamAPS FX, zkontrolujte, prosím, webové stránky výrobce senzoru, zda schválil kompatibilitu před aktualizací na Android OS 14. Upozorňujeme, že v nastavení telefonu mohou být zapnuté automatické aktualizace.',
	
	header_13:'BEZPEČNOSTNÍ UPOZORNĚNÍ V TERÉNU 14/11/2023',
    body_13:'BEZPEČNOSTNÍ UPOZORNĚNÍ V TERÉNU.',
    body_13_link_text:'Přečtěte si a potvrďte čtení důležitého upozornění',
    body_13_end: '. Přejděte do Menu aplikace -> Bezpečnostní upozornění.',
    body_13_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET5604+Mylife+Users+final+(2)+-+CZ.pdf',

	header_12:'Aktualizace uživatelské příručky 10/11/2023',
    body_12:'K dispozici je aktualizovaná verze uživatelské příručky.',
	
	header_11:'Android OS 14. 12/09/2023',
    body_11:'Aby bylo zajištěno nepřetržité používání aplikace mylife CamAPS FX, zkontrolujte, prosím, webové stránky výrobce senzoru, zda schválil kompatibilitu před aktualizací na Android OS 14. Upozorňujeme, že v nastavení telefonu mohou být zapnuté automatické aktualizace.Před aktualizací na Android OS 14 se ujistěte, že používáte aplikaci mylife CamAPS FX verze 1.4(173).',
	
	header_10:'BEZPEČNOSTNÍ UPOZORNĚNÍ V TERÉNU 15/08/2023',
    body_10:'BEZPEČNOSTNÍ UPOZORNĚNÍ V TERÉNU. Přečtěte si a potvrďte čtení důležitého upozornění. Přejděte do Menu aplikace -> Bezpečnostní upozornění.',
	
	header_9:'Aktualizace uživatelské příručky 24/07/2023',
    body_9:'K dispozici je aktualizovaná verze uživatelské příručky.',
	
	header_8:'Kompatibilita Glooko 21/07/2023',
    body_8:'Jak bylo oznámeno dříve letos, diasend bude ukončen 28. července. Pokud chcete i nadále sdílet data se svým diabetologickým týmem, aktualizujte své diasend konto na Glooko nebo si vytvořte nové konto Glooko. Aktualizujte na nejnovější verzi mylife CamAPS FX, zadejte své nové jméno a heslo Glooko v menu sdílení a restartujte smartphone. Diasend bude i nadále dostupný pro prohlížení historických dat po zbytek roku.',
	
	header_7:'Samsung A-Series 17/07/2023',
    body_7:'Uživatelé modelů Samsung A-Series (např. A53, A33) po poslední aktualizaci Samsung One UI 5.1 možná zaznamenali ztrátu signálu u svého CGM senzoru. Samsung problém identifikoval a řešení je ve vývoji. Samsung plánuje 24. července (v závislosti na regionu) vydat aktualizaci One UI, která problém se ztrátou signálu vyřeší. Doporučuje se nainstalovat aktualizaci, jakmile bude k dispozici. Pokud jste ještě neaktualizovali na One UI 5.1, doporučujeme počkat na další aktualizaci Samsung One UI.',

    header_6:'Kompatibilita Glooko 02/06/2023',
    body_6:'mylife CamAPS FX je nyní kompatibilní s Glooko. Prosím, aktualizujte svou aplikaci mylife CamAPS FX. Pokud sdílíte data s klinikou, budete upozorněni prostřednictvím vašeho stávajícího účtu diasend, když klinika přejde na Glooko. Jakmile je to hotovo, zadejte své nové uživatelské jméno a heslo pro Glooko do nabídky sdílení a restartujte svůj smartphone. Prosím, aktualizujte na Glooko před 28. červencem 2023. Diasend bude dostupný pro zobrazení historických dat po zbytek roku.',

    header_5:'',
    body_5:'',

    header_4:'Aktualizace uživatelské příručky 27/05/2023',
    body_4:'K dispozici je aktualizovaná verze uživatelské příručky.',

    header_3:'SMS upozornění (Pouze Ypsopump)  11/05/2023',
    body_3:'S připravovanou aktualizací 1.4 (171) v polovině května budete moci aktivovat až 5 sledovatelů SMS a současně používat režim společníka (Companion). Pro použití režimu společníka musí mít telefon uživatele internetové připojení pro sdílení dat. Uživatelé musí mít SIM kartu, aby mohli odesílat SMS z jejich telefonu. Pokud používáte jednu z těchto možností, doporučujeme vám zkontrolovat, zda váš mobilní tarif zahrnuje pokrytí SMS a/nebo dat v závislosti na tom, kterou možnost používáte.',

    header_2:'Aktualizace kybernetické bezpečnosti (Pouze Ypsopump) 24/04/2023',
    body_2:'Bezpečnost aplikace mylife CamAPS FX má zásadní význam. Od poloviny května bude v obchodě Google Play probíhat vynucená aktualizace kybernetické bezpečnosti. Po této aktualizaci může malá část telefonů selhat při kontrole integrity kybernetické bezpečnosti. Telefon můžete předem otestovat v nabídce nápovědy a provést kontrolu. Pokud telefon touto kontrolou neprojde, zkuste aplikaci odinstalovat a znovu nainstalovat.',

    header_1:'',
    body_1:'',
};
